module.exports = __webpack_public_path__ + "static/media/v22.d9b538f7.mp4";